// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"866":"63ceeb76","970":"cbe073ec"}[chunkId] + ".chunk.js";
};